<ng-container *ngIf="$logoUrl | async as logoUrl">
  <img class="company-logo company-logo_md" data-test-id="company-logo-img-element"
        (click)="redirectToCompanyPage()"
        [ngClass]="{'company-logo_sm': small,
                    'company-logo_md': !small}"
        [src]="logoUrl" alt="company-logo" />
</ng-container>
